import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'

export default {
  name      : 'PageContent',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {
    pageTitle: {
      type   : String,
      default: ''
    },

    pageContent: {
      type   : String,
      default: ''
    }
  },
  enums    : {},
  dataStore: {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
